export enum TimeRuleDays {
  EveryDay = 'everyday',
  Weekdays = 'weekdays',
  Weekends = 'weekends',
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}

export interface ITimeRuleSet {
  rules: ITimeRule[]
  ruleOverrides: ITimeRuleOverride[]
}

export interface ITimeRule extends ITimeRange {
  days: TimeRuleDays
}

export interface ITimeRuleOverride {
  date: string
  rules: ITimeRange[]
}

export interface ITimeRange {
  startTs: number
  endTs: number
}
